import { EntityName } from 'record-it-time-common/EntityName';
import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';

export function useWorkTimeEntryDeleteHandler(
  workTimeEntry: WorkTimeEntry
): () => void {
  return useEntityDeleteHandler(
    EntityName.WorkTimeEntry,
    workTimeEntry,
    (wte) =>
      DateUtils.withCurrentTimezone().formatDateRange(
        wte.startDate,
        wte.endDate
      )
  );
}
